import type { ReactNode } from 'react';

import { useReportPreviewModal } from '@mint-lib/ai-chat';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  chatList: ReactNode;
  header: ReactNode;
  chat: ReactNode;
  reportPreview: ReactNode;
};

const AgenticAiModalFullScreen = ({
  header,
  chatList,
  chat,
  reportPreview,
}: Props) => {
  const { open: reportPreviewOpen } = useReportPreviewModal();

  return (
    <div className="h-full w-full">
      <div className="flex h-full w-full flex-col">
        {header}
        <div className="flex h-full w-full flex-row gap-6 pt-8 pr-8 pb-13.5 pl-10">
          {chatList}
          <div
            className={cn('flex h-full w-full min-w-0 flex-col', {
              hidden: !!reportPreview && reportPreviewOpen,
            })}
          >
            {chat}
          </div>
          {reportPreview}
        </div>
      </div>
    </div>
  );
};

export default AgenticAiModalFullScreen;
